import { GetConversationParticipantSignature, GetConversationSignature, User } from '@centecomm/portal-service';

import { Streams, State } from '../../Types';

import { conversationMessageReadHandler } from './MessageHandlers/conversationMessageReadHandler';

import { conversationEndedHandler } from './MessageHandlers/conversationEndedHandler';
import { messageSentToConversationHandler } from './MessageHandlers/messageSentToConversationHandler';

import { participantJoinedConversationHandler } from './MessageHandlers/participantJoinedConversationHandler';
import { participantLeftConversationHandler } from './MessageHandlers/participantLeftConversationHandler';
import { participantWasInvitedToConversationHandler } from './MessageHandlers/participantWasInvitedToConversationHandler';
// eslint-disable-next-line max-len
import { participantWasRemovedFromConversationHandler } from './MessageHandlers/participantWasRemovedFromConversationHandler';
import { alertCreatedHandler } from './MessageHandlers/alertCreatedHandler';

import * as SignalR from '@microsoft/signalr';

declare const $: any;

const serverMethods = {
    AlertCreated: 'alertCreated',
    ConversationEnded: 'conversationEnded',
    ConversationMessageRead: 'conversationMessageRead',
    MessageSentToConversation: 'messageSentToConversation',
    ParticipantJoinedConversation: 'participantJoinedConversation',
    ParticipantLeftConversation: 'participantLeftConversation',
    ParticipantWasRemovedFromConversation: 'participantWasRemovedFromConversation',
    ParticipantWasInvitedToConversation: 'participantWasInvitedToConversation',
};

const hubConnectionThunk =
    (
        token: string,
        currentUser: User,
        getConversation: GetConversationSignature,
        getConversationParticipant: GetConversationParticipantSignature,
    ) =>
    (dispatch, getState): any => {
        const connection = new SignalR.HubConnectionBuilder()
                    .withUrl(`${API_ROOT}/signalr`, {
                        withCredentials: true,
                        accessTokenFactory: () => token,            
                    })
                    .configureLogging({
                        log: (loglevel, message) => { }
                    })
                    .withAutomaticReconnect()
                    .build();

        connection.on(serverMethods.AlertCreated, (stream: Streams.AlertCreatedEvent) => {
            alertCreatedHandler(stream, dispatch);
        });

        connection.on(serverMethods.ConversationEnded, (stream: Streams.ConversationEndedStreamMessage) => {
            const { conversations }: State = getState();

            conversationEndedHandler(stream, conversations.conversations, dispatch);
        });

        connection.on(serverMethods.ConversationMessageRead, (stream: Streams.ConversationMessageReadStreamMessage) => {
            const { conversations }: State = getState();

            conversationMessageReadHandler(
                stream,
                conversations.conversations,
                conversations.conversationEvents,
                currentUser?.id,
                dispatch,
                getConversation,
            );
        });

        connection.on(serverMethods.MessageSentToConversation, (stream: Streams.MessageSentToConversationStreamMessage) => {
            const { conversations }: State = getState();

            messageSentToConversationHandler(
                stream,
                conversations.conversations,
                conversations.conversationEvents,
                currentUser?.id,
                dispatch,
                getConversation,
            );
        });

        connection.on(
            serverMethods.ParticipantJoinedConversation,
            (stream: Streams.ParticipantJoinedConversationStreamMessage) => {
                const { conversations: conversationsState }: State = getState();
                const { conversations, conversationEvents, conversationParticipants } = conversationsState;

                participantJoinedConversationHandler(
                    stream,
                    conversations,
                    conversationEvents,
                    conversationParticipants,
                    currentUser?.id,
                    dispatch,
                    getConversation,
                    getConversationParticipant,
                );
            },
        );

        connection.on(
            serverMethods.ParticipantLeftConversation,
            (stream: Streams.ParticipantLeftConversationStreamMessage) => {

                participantLeftConversationHandler(stream, currentUser?.id, dispatch);
        });

        connection.on(
            serverMethods.ParticipantWasInvitedToConversation,
            (stream: Streams.ParticipantWasInvitedToConversationStreamMessage) => {
                const { conversations: conversationsState }: State = getState();

                const { conversations, conversationEvents, conversationParticipants } = conversationsState;

                participantWasInvitedToConversationHandler(
                    stream,
                    conversations,
                    conversationEvents,
                    conversationParticipants,
                    currentUser?.id,
                    dispatch,
                    getConversation,
                    getConversationParticipant
                );
            },
        );

        connection.on(
            serverMethods.ParticipantWasRemovedFromConversation,
            (stream: Streams.ParticipantWasRemovedFromConversationStreamMessage) => {

                participantWasRemovedFromConversationHandler(stream, currentUser?.id, dispatch);
            },
        );

        connection
            .start()
            .catch((err) => {});

        return (next) => (action) => next(action);
};

export default hubConnectionThunk;
